import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_840e48bf683d229cb72546e3ba5a5c0c/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_840e48bf683d229cb72546e3ba5a5c0c/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}